<template>
<div style="margin-left: 30px; margin-top: 30px;">
  <h4>Set desired version number for the following orgs</h4>
  <v-layout row style="margin-left: 1px;">
    <v-flex xs6>
      <p/>
      <v-select
        dense
        outlined
        v-model="setOrgs"
        :items="orgs"
        multiple
        label="Set App Version for These Orgs"
        item-text="fullName"
        item-value="_id"
        >
      </v-select>
    </v-flex>
    <v-flex xs4 style="margin-left: 20px; margin-top: 16px;">
      <v-text-field dense outlined v-model="appVersion" label="App Build Number" />
    </v-flex>
  </v-layout>
  <v-btn 
    color="blue" 
    :disabled="setOrgs.length == 0 || appVersion == null"
    @click="save"
    >Set</v-btn>
  </div>
</template>

<script>
import axiosInstances from "@/../../coreui/server/axiosInstances"

export default {
  data: () => ({
    orgs: [],
    masterorgs: [],
    setOrgs: [],
    appVersion: null
  }),
  methods: {
    save () {
      if (this.setOrgs[0].fullName == 'All') {
        console.log('updating ', this.masterorgs)
      } else {
        console.log('updating ', this.setOrgs)
      }
    }
  },
  async mounted () {
    this.orgs = []
    let res = await axiosInstances.loginServer.get('/dt/v1/org?IsFacility=no&return=fullName')
    this.masterorgs = res.data
    this.orgs = [{'fullName': 'All', _id: -1}, ...this.masterorgs ]
    console.log(this.masterorgs, this.orgs)
  }
}
</script>
